document.addEventListener('DOMContentLoaded', function () {
  const assetsTab = {
    tabEquity: 'Equity-tabs',
    tabDebt: 'Debts-tabs',
  };

  const schemeTab = {
    sectorTab: 'sector',
    companyTab: 'companys',
  };

  for (const tabId in assetsTab) {
    const tabElement = document.getElementById(tabId);
    if (tabElement) {
      tabElement.addEventListener('click', function () {
        openTab(assetsTab[tabId], assetsTab);
      });
    } else {
      console.error(`Element with ID ${tabId} not found.`);
    }
  }

  for (const tabId in schemeTab) {
    const tabElement = document.getElementById(tabId);
    if (tabElement) {
      tabElement.addEventListener('click', function () {
        openTab(schemeTab[tabId], schemeTab);
      });
    } else {
      console.error(`Element with ID ${tabId} not found.`);
    }
  }

  function openTab(tabName, tabs) {
    const tabContents = Object.values(tabs).map((id) =>
      document.getElementById(id),
    );
    tabContents.forEach((content) => {
      if (content) content.style.display = 'none';
    });

    const tabButtons = Object.keys(tabs).map((id) =>
      document.getElementById(id),
    );
    tabButtons.forEach((button) => {
      if (button) button.className = button.className.replace(' active', '');
    });

    const selectedTab = document.getElementById(tabName);
    if (selectedTab) selectedTab.style.display = 'block';

    const activeTab = Object.keys(tabs).find((key) => tabs[key] === tabName);
    const activeTabElement = document.getElementById(activeTab);
    if (activeTabElement) activeTabElement.className += ' active';
  }

  openTab('Equity-tabs', assetsTab);
  openTab('sector', schemeTab);
});

document.addEventListener('DOMContentLoaded', function () {
  const toggleEquityButton = document.getElementById('toggleEquityVisibility');
  const equityItems = document.querySelectorAll(
    '#holding-section .holding-item',
  );
  let showAllEquity = false;

  const toggleDebtButton = document.getElementById('toggleDebtVisibility');
  const debtItems = document.querySelectorAll('#Debts-tabs .debt-item');
  let showAllDebt = false;

  const toggleSectorButton = document.getElementById('toggleSectorVisibility');
  const sectorItems = document.querySelectorAll('#sector-section .sector-item');
  let showAllSectors = false;

  const toggleCompanyButton = document.getElementById(
    'toggleCompanyVisibility',
  );
  const companyItems = document.querySelectorAll(
    '#company-section .company-item',
  );
  let showAllCompanies = false;

  if (equityItems.length <= 7) {
    toggleEquityButton.style.display = 'none';
  }

  toggleEquityButton.addEventListener('click', function (e) {
    e.preventDefault();
    showAllEquity = !showAllEquity;

    equityItems.forEach((item, index) => {
      if (index >= 7) {
        item.style.display = showAllEquity ? 'block' : 'none';
      }
    });

    toggleEquityButton.textContent = showAllEquity ? 'Show Less' : 'See All';
  });

  if (debtItems.length <= 7) {
    toggleDebtButton.style.display = 'none';
  }

  toggleDebtButton.addEventListener('click', function (e) {
    e.preventDefault();
    showAllDebt = !showAllDebt;

    debtItems.forEach((item, index) => {
      if (index >= 7) {
        item.style.display = showAllDebt ? 'block' : 'none';
      }
    });

    toggleDebtButton.textContent = showAllDebt ? 'Show Less' : 'See All';
  });

  if (sectorItems.length <= 7) {
    toggleSectorButton.style.display = 'none';
  }

  toggleSectorButton.addEventListener('click', function (e) {
    e.preventDefault();
    showAllSectors = !showAllSectors;

    sectorItems.forEach((item, index) => {
      if (index >= 7) {
        item.style.display = showAllSectors ? 'block' : 'none';
      }
    });

    toggleSectorButton.textContent = showAllSectors ? 'Show Less' : 'See All';
  });

  if (companyItems.length <= 7) {
    toggleCompanyButton.style.display = 'none';
  }

  toggleCompanyButton.addEventListener('click', function (e) {
    e.preventDefault();
    showAllCompanies = !showAllCompanies;

    companyItems.forEach((item, index) => {
      if (index >= 7) {
        item.style.display = showAllCompanies ? 'block' : 'none';
      }
    });

    toggleCompanyButton.textContent = showAllCompanies
      ? 'Show Less'
      : 'See All';
  });
});
